module.exports = __webpack_public_path__ + "img/float-btn-esports.36c0053e.svg";